<template>
    <div class="homepage-container">
        <div class="banner-container">
          <transition name="slide-fade"> 
            <div class="left-container" v-if="!showTwo">
              <div class="title">
                  <p>飞视巡检</p>
                  <p>赋能无人化巡检服务网，让巡检更简单</p>
              </div>
              <img class="play-btn" :src="require('@/assets/images/HomePage/banner/play.png')" alt="播放图标加载失败" @click=" videoVisible = true "> 

              <div class="video-container"  v-if="videoVisible">
                  <video class="video-box" src="https://flysee-business.oss-cn-hangzhou.aliyuncs.com/video/%E5%B1%95%E4%BC%9A%E8%A7%86%E9%A2%912025-720P.mp4" autoplay loop controls>
                  </video>
                  <img class="cancel-btn" :src="require('@/assets/images/HomePage/banner/cancel.png')" alt="关闭图标加载失败" v-if="videoVisible" @click=" videoVisible = false ">    
              </div>
            </div>
          </transition>
          <transition name="slide-fade"> 
            <div class="right-container" v-if="showTwo"></div>
          </transition>
          <div class="switch">
            <div class="progress-bar" @click="switchProcess(false)">
              <div class="progress" ref="progress1" :class="{'playing': !showTwo}"></div>
            </div>
            <div class="progress-bar" @click="switchProcess(true)">
              <div class="progress" ref="progress2" :class="{'playing': showTwo}"></div>
            </div>
          </div>
        </div>
        <!-- 飞行巡检 -->
        <div class="flight-container">
            <div class="title">
                <p>飞视平台</p>
                <p>专注智能、高效、实用、安全无人化巡检</p>
            </div>
            <div class="flight-box">
                <div class="flight-child" v-for="(item,key) in flightData" :key = "key" @mouseover="flightHoverID = item.id">
                    <img class="icon" :src="item.imgURL" alt="图标加载失败">
                    <p class="title">{{item.title}}</p>
                    <p class="content">{{item.content}}</p>
                    <div class="trigger" :style="getFlightStyle(item.id)"></div>
                </div>
            </div>
        </div>
        <!-- 我们的特色 -->
        <div class="character-container">
            <img class="icon" :src="require('@/assets/images/HomePage/character/icon.png')" alt="图标加载失败">
            <p class="title1">我们的特色</p>
            <p class="title2">不断创新的产品、客户至上的服务</p>
            <div class="character-row1">
                <!-- fsGPT -->
                <div class="character-fsGPT" :style="getCharacterHoverLayout(1)" @mouseover="changeLayout(1)">
                    <div class="trigger" :style="getCharacterTrigger(1)"></div>
                    <div :style="getCharacterTitleHover(1)">
                        <p class="subtitle">{{characterData[0].title}}</p>
                        <p class="content" :style="getCharacterContentHover(1)">{{characterData[0].content}}</p>
                        <div class="tag-box" v-if="row1HoverID === 1">
                            <div class="tag" v-for="(tag,index) in characterData[0].tags" :key="index">{{tag}}</div>
                        </div>
                    </div>
                </div>
                <!-- 三维底座 -->
                <div class="character-dimensional" :style="getCharacterHoverLayout(2)" @mouseover="changeLayout(2)">
                    <div class="trigger" :style="getCharacterTrigger(2)" ></div>
                    <div :style="getCharacterTitleHover(2)">
                        <p class="subtitle">{{characterData[1].title}}</p>
                        <p class="content" :style="getCharacterContentHover(2)">{{characterData[1].content}}</p>
                        <div class="tag-box" v-if="row1HoverID === 2">
                            <div class="tag" v-for="(tag,index) in characterData[1].tags" :key="index">{{tag}}</div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="character-row2">
                <!-- AI托管 -->
                <div class="character-ai" :style="getCharacterHoverLayout(3)" @mouseover="changeLayout(3)">
                    <div class="trigger" :style="getCharacterTrigger(3)"></div>
                    <div :style="getCharacterTitleHover(3)">
                        <p class="subtitle">{{characterData[2].title}}</p>
                        <p class="content" :style="getCharacterContentHover(3)">{{characterData[2].content}}</p>
                        <div class="tag-box" v-if="row2HoverID === 3">
                            <div class="tag" v-for="(tag,index) in characterData[2].tags1" :key="index">{{tag}}</div>
                        </div>
                        <div class="tag-box" v-if="row2HoverID === 3">
                            <div class="tag" v-for="(tag,index) in characterData[2].tags2" :key="index">{{tag}}</div>
                        </div>
                    </div>
                </div>
                <!-- 41安全保障 -->
                <div class="character-safety" :style="getCharacterHoverLayout(4)"  @mouseover="changeLayout(4)">
                    <div class="trigger" :style="getCharacterTrigger(4)"></div>
                    <div :style="getCharacterTitleHover(4)">
                        <p class="subtitle">{{characterData[3].title}}</p>
                        <p class="content" :style="getCharacterContentHover(4)">{{characterData[3].content}}</p>
                        <div class="tag-box" v-if="row2HoverID === 4">
                            <div class="tag" v-for="(tag,index) in characterData[3].tags" :key="index">{{tag}}</div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <!-- 增值服务 -->
        <div class="service-container">
            <div class="title">
                <p>增值服务</p>
                <p>低成本高效率实现大范围城市3D建模</p>
            </div>
            <div class="service-box">
                <div class="service-child" v-for="(item,key) in serviceData" :key="key" @mouseover="serviceHoverID = item.id">
                    <img class="icon" :src="item.imgURL" alt="图标加载失败">
                    <p class="subtitle">{{item.title}}</p>
                    <div class="content">
                        <p>{{item.content1}}</p>
                        <p>{{item.content2}}</p>
                    </div>
                    <div class="trigger" :style="getServiceStyle(item.id)"></div>
                </div>
            </div>
        </div>
        <!-- 行业应用 -->
        <div class="application-container">
            <div class="title">
                <p>行业应用</p>
                <p>N+应用行业&nbsp;&nbsp;&nbsp;&nbsp;70+AI识别场景</p>
            </div>
            <div class="description-container">
                <div v-for="(items, index) in applicationData" :key="index" class="description-box">
                    <img :src="items.imgURL" alt="图片展示失败">
                    <div class="cover-box"></div>
                    <div class="subtitle">{{items.title}}</div>
                    <div class="underline"></div>
                    <div class="item-box">
                        <div class="item" v-for="(item, index) in items.description" :key="index">{{item}}</div>
                    </div>
                    <div class="trigger"></div>
                </div>
            </div>
        </div>
        <!-- 合作伙伴 -->
        <div class="partner-container">
            <div class="title">
                <p>合作伙伴</p>
                <p>越来越多优秀的企业选择与我们合作</p>
            </div>
            <div class="partner-box">
                <div class="partner-row" v-for="(rows,key) in partnerData" :key="key">
                    <div class="partner-col" v-for="(item,index) in rows" :key="index">
                        <img class="icon" :src="require('@/assets/images/HomePage/partner/'+item)" alt="伙伴图标加载失败">
                    </div>
                </div>
            </div>
        </div>
        <!-- 服务客户 -->
        <div class="customer-container">
            <div class="title">服务客户</div>
            <div class="description-container">
                <div v-for="(items, index) in customerData" :key="index" class="description-box">
                    <div class="subtitle">{{items.title}}</div>
                    <div class="description-item" v-for="(item, index) in items.description" :key="index">
                        {{item}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Booking from './Booking.vue'
export default {
    name: 'HomePage',
    components:{
        Booking
    },
    data() {
      return{
        showBackground :false,
        goTopVisible:false,
        playHover:false,
        videoVisible:false,
        bookingVisible:false,
        flightData:[
            {id:1,imgURL:require('@/assets/images/HomePage/FlightInspection/工作台.png'),title:'业主工作台',content:'便捷易用、功能强大、让飞行更为简单的智慧巡检系统；平台支持账号管理、机场管理、数据管理等，更有AI托管、fsGPT等特色功能'},
            {id:2,imgURL:require('@/assets/images/HomePage/FlightInspection/大屏看板.png'),title:'大屏看板',content:'智能无人飞控系统，支持查看多种数据统计、历史照片查看、三维全景正射等模型查看、接入第三方渠道助力基层治理执法；实现一次飞行、多点共查、智慧交办的“巡检一张网”'},
            {id:3,imgURL:require('@/assets/images/HomePage/FlightInspection/小程序.png'),title:'飞视巡检助手',content:'轻量配套小程序，集成核心功能，在手机上即可实现智慧巡检全流程'}
        ],
        flightHoverID: 1,
        characterData:[
            {id:1,title:'fsGPT',content:'会说话就会一切，让交互变得更简单',tags:['执行任务','查询数据','知识问答'],layout:{}},
            {id:2,title:'三维底座',content:'基于视频生成区域地形，提高作业效率，保障作业安全',tags:[],layout:{}},
            {id:3,title:'AI托管',content:'全自动飞行，执行任务更高效',tags1:['自动排期调度','自动统计分析','自动航线规划','自动数据生产'],tags2:['自动飞行预警','自动分析推送','自动飞行调度'],layout:{}},
            {id:4,title:'41项安全保障',content:'全方位保障安全，让用户使用更加安心',tags:['数据保障','算法保障','硬件保障','金融保障','流程保障'],layout:{}}
        ],
        characterHoverLayout:[
            [{flexGrow: '999',maxWidth: '936px'},{flexGrow: '1'},{flexGrow: '1'},{flexGrow: '999',maxWidth: '936px'}], //盒子布局
            [{marginTop:'29px'},{marginTop:'197px'},{marginTop:'197px'},{marginTop:'29px'}], //文字框
            [{opacity:'1'},{opacity:'0'},{opacity:'0'},{opacity:'1'}], //左上角触发框
            [{fontSize:'18px'},{fontSize:'16px'},{fontSize:'16px'},{fontSize:'18px'}]
        ],
        row1HoverID:1,row2HoverID:4,
        serviceData:[
            {id:1,imgURL:require('@/assets/images/HomePage/service/标-全景.png'),title:'全景影像服务',content1:'无人机巡检过程拍摄并生成全景影像，',content2:'并在平台进行展示'}, 
            {id:2,imgURL:require('@/assets/images/HomePage/service/标-三维.png'),title:'三维建模服务',content1:'无人机周期性采集项目图像，',content2:'通过三维实景实现项目生命周期监测监管'},
            {id:3,imgURL:require('@/assets/images/HomePage/service/标-正射.png'),title:'正射影像服务',content1:'采集目标区域正射影像，',content2:'通过系统生成正射图并导入平台地图'},
        ],
        serviceHoverID:1,
        applicationData:[
            {id:1,title:"工业园区",imgURL:require('@/assets/images/HomePage/application/工业园区.png'),description:[
                "工程3D建模","安全防护栏丢失","裸土未覆盖","疑似污水","工地扬尘",
                "渣土乱倒","工地出入口未硬化","施工废弃料","渣土车未覆盖","……"
            ]},
            {id:2,title:"农林水利",imgURL:require('@/assets/images/HomePage/application/农林水利.png'),description:[
                "水域不洁","松材线虫病","焚烧秸秆","大棚破损","河道污染",
                "耕地两非","非法盗采","水利工程","非法排污","……"
            ]},
            {id:3,title:"城市管理",imgURL:require('@/assets/images/HomePage/application/城市管理.png'),description:[
                "违停车辆","井盖破损","渣土车辆","违章建筑","交通疏导",
                "流动摊贩","店外经营","垃圾满溢","占道广告牌","……"
            ]},
            {id:4,title:"道路交通",imgURL:require('@/assets/images/HomePage/application/道路交通.png'),description:[
                "车辆违停","交通标志线模糊","道路积泥沙","道路积水","交通事故",
                "交通标志牌倾斜","井盖缺失","路面坍塌","道路破损","……"
            ]},
            {id:5,title:"乡镇街道",imgURL:require('@/assets/images/HomePage/application/乡镇街道.png'),description:[
                "在建农房","附属房建筑","附属房建材","危房隐患","暴露垃圾",
                "边坡坍塌","非粮非农化","人群聚集","占道经营","……"
            ]},
            {id:6,title:"应急救援",imgURL:require('@/assets/images/HomePage/application/应急救援.png'),description:[
                "疑似烟火","消防通道堵塞","黑烟污染","人员聚集","交通事故",
                "山体滑坡","洪涝灾害","发生火灾","……",
            ]}
        ],
        partnerData:[
            ['logo1.png','logo2.png','logo3.png','logo4.png','logo5.png','logo6.png'],
            ['logo7.png','logo8.png','logo9.png','logo10.png','logo11.png','logo12.png'],
            ['logo13.png','logo14.png','logo15.png','logo16.png','logo17.png','logo18.png']
        ],
        customerData:[
            {title:"政府客户",description:[
                "综合执法局","住建局","农林农局","应急管理局","资源规划局",
                "水利局","生态环境局","林业局","大数据局"
            ]},
            {title:"特殊应用场景客户",description:[
                "化工园区","国家公园","核电站"
            ]},
            {title:"大企业客户",description:[
                "能源管线","电力","光伏面板"
            ]}
        ],
        showTwo: false, // 展示第二个背景
        timer: null,
      }
    },
    mounted() {  
      this.start()
    },  
    methods:{
      // 开启切换背景定时器
      start(){
        this.timer = setInterval(()=>{
          if(!this.videoVisible){
            this.showTwo = !this.showTwo
          }
        },8000)
      },

      switchProcess(flag){
        this.showTwo = flag
        clearInterval(this.timer)
        this.start()
      },
        getFlightStyle(id){
            if(id === this.flightHoverID) return {width:'100%'};
            else return {width:'0%'};
        },
        getCharacterHoverLayout(id){
            return this.characterHoverLayout[0][id-1];
        },
        getCharacterTitleHover(id){
            return this.characterHoverLayout[1][id-1];
        },
        getCharacterTrigger(id){
            return this.characterHoverLayout[2][id-1];
        },
        getCharacterContentHover(id){
            return this.characterHoverLayout[3][id-1];
        },
        changeLayout(id){
            if(id<3) this.row1HoverID = id;
            else this.row2HoverID = id;

            this.characterHoverLayout[0][id - 1] = {flexGrow: '999',maxWidth: '936px'};
            this.characterHoverLayout[1][id - 1] = {marginTop:'29px',transition:'1s ease'};
            this.characterHoverLayout[2][id - 1] = {opacity:'1',transition:'1s ease'};
            this.characterHoverLayout[3][id - 1] = {fontSize:'18px',transition:'0.3s ease'};

            let tmpID = 0;
            if(id === 1 || id === 2) tmpID = 2-id;
            else tmpID = 6-id;
            
            this.characterHoverLayout[0][tmpID] = {flexGrow: '1'};
            this.characterHoverLayout[1][tmpID] = {marginTop:'197px',transition:'1s ease'};
            this.characterHoverLayout[2][tmpID] = {opacity:'0',transition:'1s ease'};
            this.characterHoverLayout[3][tmpID] = {fontSize:'16px',transition:'0.3s ease'};

            this.$forceUpdate()
        },
        getServiceStyle(id){
            if(id === this.serviceHoverID) return {width:'100%'};
            else return {width:'0%'};
        }
    },
}
</script>

<style lang="scss">
.popover, .el-popper {
    min-width: 100px;
    height: auto;
    background: #fffffff2;
    box-shadow: 0 4px 40px 0 #0000001a;
    backdrop-filter: blur(10px);
    border-radius: 10px;
    margin: 0;
    transform: translateX(-10px);
   
    .siedbar-booking{
        height: 20px;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        // color: #8935C3;
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
    }
    .phone-content{
        height: 20px;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        line-height: 20px;
    }
    .phone-number{
        height: 28px;
        font-weight: 600;
        font-size: 20px;
        color: #0271E3;
        letter-spacing: 0;
        line-height: 28px;
    }
}
</style>
<style scoped lang="scss">
.homepage-container{
    width: 100%;
    font-weight: 500;
    letter-spacing: 0px;
    color: #FFFFFF;
    background-color: #000000;
    padding: 0px;
    margin: 0;
    position: relative;
}
/* 动画效果 */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: transform 0.5s ease;
}
.slide-fade-enter, .slide-fade-leave-to /* 离开时的状态 */ {
  transform: translateX(100%);
}
.slide-fade-leave-active {
  transform: translateX(-100%);
}
  
.banner-container{
    margin: 0;
    width: 100%; /* 容器宽度占满屏幕 */  
    height: 100vh; /* 容器高度占满视口高度 */  
    position: relative;
    .left-container{
      background-image: url('@/assets/images/HomePage/banner/banner背景图.jpg'); /* 设置背景图片 */  
      background-size: cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */  
      background-position: center; /* 图片居中显示 */ 
      position: absolute;
      width: 100%; /* 容器宽度占满屏幕 */  
      height: 100vh;

      .title{
          text-align: center;
          position: absolute;
          height: auto;
          width: 100%;
          top: 31%;
          bottom:57.0%;
          flex-shrink: 1;
          z-index: 1;
          p{
              &:first-child{
                  width: 192px;
                  height: 64px;
                  font-weight: 500;
                  font-size: 48px;
                  line-height: 64px;
                  margin: 0 auto;
                  margin-bottom: 13px;
              }
              &:last-child{
                  width: 393px;
                  height: 32px;
                  font-weight: 400;
                  font-size: 22px;
                  letter-spacing: 1.1px;
                  line-height: 32px;
                  margin: 0 auto;
              }
          }
      }
      
      .play-btn{
          padding:0;
          margin:0;
          width: 92px;
          height: 92px;
          position: absolute;
          border-radius: 50%;
          left: 50%;
          top: 50%;
          z-index: 1;
          transform: translate(-50%, -50%); // 向左和向上移动自身宽高的一半，实现完全居中
          // background: #fffffff2;
          // box-shadow: 0 0 18px 0 #20528d14;
          object-fit:contain;
          display: flex;
          transition: 0.3s ease;

          &:hover{
              width: 102px;
              height: 102px;
              cursor: pointer; 
          }
      } 
      .video-container{
          width: 100%;
          height: 100vh;
          background: #00000099;
          position: fixed;
          z-index: 120;
          .video-box{
              position: absolute;
              max-width: 1280px;
              width: 66.7%;
              height: 720px;
              // background: #666666;
              left: 50%;
              top: 50%;
              transform: translate(-50%,-50%);
              object-fit: contain;
          }

          .cancel-btn{
              max-width: 36px;
              max-height: 36px;
              position: absolute;
              top: 11.67%;
              left: 83.85%;
              &:hover{
                  cursor: pointer; 
              }
          }    
      }
    }

    .right-container{
      width: 100%; /* 容器宽度占满屏幕 */  
      height: 100vh;
      background-size: cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */  
      background-position: center; /* 图片居中显示 */ 
      position: absolute;
      z-index: 1;
      // transform: translateX(100%);
      background-image: url('@/assets/images/HomePage/banner/banner-right-background.jpg');
      // animation: var(--enter) 1s ease-in-out;
    }

    // @keyframes slideRight {  
    //   from { transform: translateX(100%);  }  
    //   to { transform: translateX(0); }  
    // } 

    // @keyframes slideLeft {  
    //   from { transform: translateX(0);  }  
    //   to { transform: translateX(100%); }  
    // }  

    .switch{
      position: absolute;
      bottom: 60px;
      left: calc(50% - 46px);
      width: 92px;
      height: 3px;
      display: flex;
      .progress-bar{
        width: 40px;
        height: 3px;
        background: #9691A1;
        border-radius: 2px;
        z-index: 1;
        margin-right: 12px;
        position: relative;
        cursor: pointer;
        .progress {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          border-radius: 2px;
          width: 0;
        }
        .playing {  
          animation: fill 5s forwards;  
        }  
      }
    }

    /* 动画定义 */
    @keyframes fill {
      0% {  
        width: 0%;  
        background: #9691A1; 
      }  
      100% {  
        width: 100%;  
        background-color: white;  
      }  
    }
    
}
/* 飞行巡检 */
.flight-container{
    margin: 0;
    width: 100%;
    height: 800px;
    background-image: url('@/assets/images/HomePage/FlightInspection/background-img.jpg'); /* 设置背景图片 */  
    background-size: 100% 100%; /* 背景图宽度为100%，高度自动调整以保持宽高比 */  
    background-position: center; /* 图片居中显示 */  
    background-repeat: no-repeat; /* 不重复背景图 */  
    overflow: hidden; /* 隐藏超出容器的背景图部分（但在这个场景下其实不需要，因为background-image不会超出容器） */  
    display: flex;
    flex-direction: column;

    > .title{
        text-align: center;
        width: 100%;
        p{
            &:first-of-type{
                height: 60px;
                font-weight: 500;
                font-size: 36px;
                line-height: 60px;
                margin: 0 auto;
                margin-top: 70px;
            }
            &:last-of-type{
                height: 24px;
                font-weight: 400;
                font-size: 16px;
                color: #ffffffcc;
                line-height: 24px;
                margin: 0 auto;
                margin-top: 4px;
            }
        }
    }
    .flight-box{
        margin: 0 auto;
        margin-top:212px; 
        max-width: 1440px;
        width: calc(100% - 80px);
        height: 360px;
        overflow: auto;
        display: flex;
        text-align: center;
        justify-content: center;

        .flight-child{
            flex: 1;
            max-width: 480px;
            height: 100%;
            margin: 0;
            position: relative;

            .icon{
                max-width: 44px;
                max-height: 44px;
                margin-top: 116px; 
            }
            > .title{
                margin:0 auto;
                margin-top: 12px; 
                height: 32px;
                font-weight: 500;
                font-size: 18px;
                line-height: 32px;
            }
            .content{
                margin: 0 auto;
                margin-top: 16px;
                max-width: 320px;
                height: 101px;
                font-weight: 400;
                font-size: 14px;
                color: #ffffffcc;
                line-height: 22px;
                text-align: left;
            }
            .trigger{
                max-width: 320px;
                width: 0%;
                height: 3px;
                background: #FFFFFF;
                border-radius: 8px;
                margin: 0 auto;
                position: absolute;
                bottom: 0%;
                left: 50%; // 左侧偏移50%，为水平居中做准备  
                transform: translate(-50%, -50%); // 向左和向上移动自身宽高的一半，实现完全居中 
                transition: width 0.5s ease;
            }
        }
    }
   
}
/* 我们的特色 */
.character-container{
    width: 100%;
    height: 1104px;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    margin: 0px;

    .icon{
        width: 24px;
        height: 12px;
        flex-shrink: 1;
        margin-top: 13px;
    }
    .title1 {
        max-width: 180px;
        width: 100%;
        height: 60px;
        font-weight: 500;
        font-size: 36px;
        text-align: center;
        line-height: 60px; 
        margin: 0 auto;
        margin-top: 75px;
        text-align: center;
    }

    .title2{
        max-width: 240px;
        width: 100%;
        height: 24px;
        font-weight: 400;
        font-size: 16px;
        color: #ffffffcc;
        text-align: center;
        line-height: 24px;   
        text-align: center;
        margin: 0 auto;
        margin-top: 4px; 
    }

    .trigger{
        width: 36px;
        height: 3px;
        background: #FFFFFF;
        margin: 0;
        margin-left: 60px;
        margin-top: 80px;
    }

    .character-row1{
        display: flex;
        max-width: 1440px;
        width: calc(100% - 80px);
        height: 400px;
        margin: 0 auto;
        margin-top: 52px;
        padding: 0;

        .character-fsGPT{
            flex-grow: 10;
            flex-shrink: 1;
            max-width: 936px;
            height: 100%;
            background-image: url('@/assets/images/HomePage/character/2区块-1.png');
            border-radius: 8px;
            background-size: cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */  
            background-position: center; 
            background-repeat: no-repeat;
            overflow: hidden;
            margin-right: 24px;
            transition: flex-grow 1s ease;

            .tag-box{
                width: auto;
                height: 28px;
                margin: 0;
                margin-top: 22px;
                margin-left: 60px;
                display: flex;
                
                .tag{
                    max-width: 88px;
                    width: 100%;
                    height: 28px;
                    line-height: 28px;
                    border: 1px solid #FFFFFF;
                    border-radius: 16px;
                    margin: 0;
                    margin-right: 12px;

                    &:last-child{
                        margin: 0px;
                    }
                }
            }
        }

        .character-dimensional{
            flex-grow: 1;
            flex-shrink: 1;
            max-width: 936px;
            height: 100%;
            border-radius: 8px;
            background-image: url('@/assets/images/HomePage/character/2区块-2.png');
            background-size: cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */  
            background-position: center; 
            background-repeat: no-repeat;
            overflow: hidden;
            transition: flex-grow 1s ease;
        }
    }
    .character-row2{
        display: flex;
        max-width: 1440px;
        width: calc(100% - 80px);
        height: 400px;
        margin: 0 auto;
        margin-top: 24px;
        padding: 0;

        .character-ai{
            flex-grow: 1;
            flex-shrink: 1;
            max-width: 936px;
            height: 100%;
            background-image: url('@/assets/images/HomePage/character/2区块-3.png');
            border-radius: 8px;
            background-size: cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */  
            background-position: center; 
            background-repeat: no-repeat;
            overflow: hidden;
            margin-right: 24px;
            transition: flex-grow 1s ease;

            .tag-box{
                width: 396px;
                width: 100%;
                height: 28px;
                margin: 0;
                margin-left: 60px;
                margin-top: 12px;
                display: flex;

                .tag{
                    max-width: 102px;
                    width: 100%;
                    height: 28px;
                    line-height: 28px;
                    border-right: 1px solid #ffffff;
                    margin: 0;
                    height: 20px;
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 20px;
                    text-align: center;
                    &:first-of-type{
                        max-width: 90px;
                        width: 100%;
                        text-align: left;
                    }
                    &:last-of-type{
                        border-right: 0px solid #ffffff;
                    }
                }
            }
        }

        .character-safety{
            flex-grow: 10;
            flex-shrink: 1;
            max-width: 936px;
            height: 100%;
            border-radius: 8px;
            background-image: url('@/assets/images/HomePage/character/2区块-4.png');
            background-size:cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */  
            background-position: center; 
            background-repeat: no-repeat;
            overflow: hidden;
            transition: flex-grow 1s ease;

            .tag-box{
                width: auto;
                height: 28px;
                margin: 0;
                margin-top: 20px;
                margin-left: 60px;
                display: flex;
                .tag{
                    flex: 1;
                    max-width: 88px;
                    width: 100%;
                    height: 28px;
                    line-height: 28px;
                    border: 1px solid #FFFFFF;
                    border-radius: 16px;
                    margin: 0;
                    margin-right: 12px;

                    &:last-child{
                        margin: 0px;
                    }
                }
            }
        }
    }

    .subtitle{
        width: auto;
        height: 32px;
        font-weight: 500;
        font-size: 24px;
        line-height: 32px;
        text-align: left;
        margin: 0;
        margin-left: 60px;
    }
    .content{
        width: 75%;
        height: 28px;
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        margin-top: 10px;
        margin-left: 60px;
        margin-bottom: 22px;
        text-align: left;
    }
}
/* 增值服务 */
.service-container{
    margin: 0;
    width: 100%;
    height: 560px;

    .title p{
        
        text-align: center;

        &:first-of-type{
            margin: 0 auto;
            margin-top: 70px;
            width: 144px;
            height: 60px;
            font-weight: 500;
            font-size: 36px;
            line-height: 60px;
        }
        &:last-of-type{
            margin: 0 auto;
            margin-top: 4px;
            width: 261px;
            height: 24px;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #ffffffcc;
        }
    }
    .service-box{
        margin: 0 auto;
        margin-top:22px; 
        max-width: 1440px;
        width: calc(100% - 80px);
        height: 335px;
        overflow: auto;
        display: flex;
        text-align: center;
        justify-content: center;

        .service-child{
            flex: 1;
            max-width: 480px;
            height: 100%;
            margin: 0;
            flex-shrink: 1; 
            position: relative;

            .trigger{
                position: absolute;
                max-width: 320px;
                width: 0%;
                height: 3px;
                background: #FFFFFF;
                border-radius: 8px;
                margin: 0 auto;
                bottom: 0%;
                left: 50%; // 左侧偏移50%，为水平居中做准备  
                transform: translate(-50%, -50%); // 向左和向上移动自身宽高的一半，实现完全居中 
                transition: width 0.5s ease;
            }
        }
        .icon{
            max-width: 80px;
            max-height: 80px;
            margin: 0 auto;
            margin-top: 80px; 
            flex-shrink: 1;
        }
        .subtitle{
            margin:0 auto;
            margin-top: 16px; 
            max-width: 120px;
            height: 32px;
            font-weight: 500;
            font-size: 20px;
            text-align: center;
            line-height: 32px;
        }
        .content{
            margin: 0 auto;
            margin-top: 16px;
            max-width: 360px;
            height: 44px;
            font-weight: 400;
            font-size: 14px;
            text-align: center;
            line-height: 22px;
            color: #ffffffcc;
        }
        p{
            margin: 0px;
        }
    }
}
/* 行业应用*/
.application-container{
    width: 100%;
    height: 680px;
    position: relative;
    display: flex;
    text-align: center;

    .title {
        position: absolute;
        width: auto;
        z-index: 10;
        left: 50%; // 左侧偏移50%，为水平居中做准备  
        top: 10.6%;
        transform: translate(-50%, 0%); // 向左和向上移动自身宽高的一半，实现完全居中 
        padding: 0;        
        p{
            &:first-of-type{
                width: auto;
                height: 60px;
                font-weight: 500;
                font-size: 36px;
                color: #FFFFFF;
                line-height: 60px;
                margin: 0 auto;
                margin-bottom: 4px;
            }
            &:last-of-type{
                width: auto;
                height: 24px;
                font-weight: 400;
                font-size: 16px;
                color: #ffffffcc;
                line-height: 24px;
                margin: 0;
            }
        }    
    }
    .description-container{
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;

        .description-box{
            flex: 1;
            flex-shrink: 1;
            position: relative;
            margin: 0;
            overflow: hidden;
            text-align: center;
            padding: 0;

            img{
                position: absolute;
                height: 100%;
                object-fit: cover;
                object-position: center;
                left: 0%;
                z-index: 1;
                transition: transform 0.5s ease; // 平滑过渡效果  
            }
            .cover-box{
                position: absolute;
                z-index: 2;
                width: 100%;
                height: 100%;
                background-color: #000000;
                opacity: 0.25;
            }
            .subtitle{
                position: absolute;
                z-index: 3;
                width: 100%;
                text-align: center;
                height: 36px;
                font-weight: 500;
                font-size: 20px;
                line-height: 36px;
                margin: 0 auto;
                top: 83%;
                transition: top 0.5s ease;
            }
            .underline{
                position: absolute;
                top: 100%; 
                left: 50%; // 左侧偏移50%，为水平居中做准备  
                transform: translate(-50%, -50%); // 向左和向上移动自身宽高的一半，实现完全居中 
                max-width:36px;
                height: 0px;
                width: 100%;
                background: #FFFFFF;  
                transition: top 0.5s ease;
                z-index: 3;
            }
            .item-box{
                position: absolute;
                width: auto;
                height: auto;
                top: 100%;
                transform: translateY(0); /* 初始位置 */  
                transition: transform 0.5s ease; 
                padding: 0 20px;
                z-index: 3;

                display: flex;
                flex-wrap: wrap; /*允许子元素换行*/

                .item{
                    flex: 1 0 50%;
                    height: 36px;
                    box-sizing: border-box;/*是的padding和border包含在元素宽度内*/
                    margin: 0;
                    margin-bottom: 10px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #ffffffcc;
                    text-align: center;
                    line-height: 36px;
                }
                // 媒体查询，当屏幕宽度小于某个值时，改为单列布局  
                @media (max-width: 1200px) {  
                    .item-box{
                        flex-direction: column;
                    }
                    .item{
                        flex: 1 0 100%;
                        margin: 0;
                    }
                }
            }
            .trigger{
                position: absolute;
                width: 100%;
                height: 0px;
                background-image: linear-gradient(90deg, #FFFFFF 0%, #0271E3 100%);
                box-shadow: 0 4px 16px 0 #0000001a;
                z-index: 10;
                
                bottom: 0%;
            }

            &:hover{
                .trigger{
                    height: 4px;
                }
                img{
                    // 放大图片到原始尺寸的150%  
                    transform: scale(1.5);  
                    object-fit: cover;
                    filter: blur(3px);
                }
                .cover-box{
                    opacity: 0.5;
                    background: #000000;
                }
                .subtitle{
                    // margin-top: 254px;
                    top: 37.4%;
                }
                .underline{
                    height: 3px;
                    top: 45%;
                }
                .item-box{
                    transform: translateY(-334px); /* 初始位置 */ 
                }

                @media (max-width: 1200px) { 
                    .subtitle{
                        // margin-top: 218px;
                        top: 34.7%;
                    }
                    .underline{
                        height: 3px;
                        top: 42.3%;
                    } 
                    .item-box{
                        transform: translateY(-370px); /* 初始位置 */ 
                    }
                }
            }
        }
    }
}
/* 合作伙伴 */
.partner-container{
    height: 630px;
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;

    .title p{
        &:first-of-type{
            margin: 0 auto;
            margin-top: 70px;
            width: 144px;
            height: 60px;
            font-weight: 500;
            font-size: 36px;
            line-height: 60px;
            width: 144px;
        }
        &:last-of-type{
            margin: 0 auto;
            margin-top: 4px;
            width: 256px;
            height: 24px;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #ffffffcc;
        }
        
    }
    .partner-box{
        margin: 0 auto;
        margin-top:62px; 
        margin-bottom: 74px;
        max-width: 1440px;
        width: calc(100% - 80px);
        min-height: 336px;
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .partner-row {
            flex: 1;
            margin: 0 auto;
            margin-bottom: 6px;
            display: flex;
            width: 100%;
            height: 108px;
            flex-shrink: 1;

            &:last-child{
                margin: 0 auto;
            }
            .partner-col{
                display: flex;
                flex: 1;
                flex-shrink: 1;
                margin: 0 auto;
                margin-right: 6px;
                max-width: 235px;
                width: 100%;
                height: 108px;
                border-radius: 4px;
                background: #0F0F12;
                border-radius: 4px;
                overflow: hidden;
                padding:58px auto;

                &:last-child{
                    margin: 0 auto;
                }

                .icon{
                    flex-shrink: 1;
                    
                    width: 90%;
                    height: auto;
                    object-fit: contain; /* 保持宽高比，不裁剪   */
                    transition: transform 0.5s ease; // 平滑过渡效果  
                    margin: 0 auto;
                }
                
                &:hover{
                    .icon{
                        // 放大图片到原始尺寸的130%  
                        transform: scale(1.2); 
                    }
                }
            }
        }
    }
}
/* 服务客户 */
.customer-container{
    width: 100%;
    height: 480px;
    background-image: url('@/assets/images/HomePage/customer/customer.jpg');
    background-size:cover; /* 覆盖整个容器，图片可能会被裁剪以填满容器 */  
    background-position: center; 
    background-repeat: no-repeat;
    overflow: hidden;
    
    display: flex;
    flex-direction: column;
    position: relative;

    .title{
        width: 75%;
        margin: 0 auto;
        margin-top: 70px;
        text-align: center;
        height: 60px;
        font-weight: 500;
        font-size: 36px;
        line-height: 60px;
    }
    .description-container{
        position: absolute;
        display: flex;
        flex-direction: column;
        max-width: 1440px;
        width: calc(100% - 80px);
        top: 38.75%;
        left: 50%; // 左侧偏移50%，为水平居中做准备  
        transform: translate(-50%, 0); // 向左和向上移动自身宽高的一半，实现完全居中 
        z-index: 1;

        .description-box{/*行*/
            flex: 1;
            width: auto;
            height: 40px;
            margin-left: 0px;
            margin-bottom: 24px;
            display: flex;
            flex-wrap: wrap; // 允许flex项目在必要时换行  

            &:last-child{
                margin-bottom: 0px;
            }

            .subtitle{
                max-width: 188px;
                width: 100%;
                height: 40px;
                border: 1.6px solid #FFFFFF;
                border-radius: 20px;
                font-weight: 500;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                line-height: 20px;
                display: flex;
                justify-content: center; /* 水平居中 */  
                align-items: center; 
                margin: 0;
                margin-right: 16px;
            }

            .description-item{
                width: auto;
                height: 20px;
                
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                margin: auto 0;
                margin-left:36px; 
                flex-shrink: 1;
            }
        }
    }
}
</style>